/*
 * 1DS JS SDK QoS plugin, 3.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* QosEvent.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2018
*/
import { isValueAssigned } from "@microsoft/1ds-core-js";
var QosEvent = /** @class */function () {
  function QosEvent() {}
  QosEvent.prototype._setCommonProperties = function (event, eventData) {
    // Part A
    if (isValueAssigned(eventData.cV)) {
      event.ext = event.ext || {};
      event.ext["mscv"] = event.ext["mscv"] || {};
      event.ext["mscv"]["cV"] = eventData.cV;
    }
    // Part B
    event.baseData["operationName"] = eventData.operationName;
    event.baseData["latencyMs"] = eventData.latencyMs;
    event.baseData["serviceErrorCode"] = eventData.serviceErrorCode || -1.0;
    event.baseData["succeeded"] = eventData.succeeded;
    event.baseData["requestStatus"] = eventData.requestStatus;
    event.baseData["requestMethod"] = eventData.requestMethod;
    if (isValueAssigned(eventData.target)) {
      event.baseData["target"] = eventData.target;
    }
    if (isValueAssigned(eventData.responseContentType)) {
      event.baseData["responseContentType"] = eventData.responseContentType;
    }
    if (isValueAssigned(eventData.protocol)) {
      event.baseData["protocol"] = eventData.protocol;
    }
    if (isValueAssigned(eventData.protocolStatusCode)) {
      event.baseData["protocolStatusCode"] = eventData.protocolStatusCode;
    }
  };
  return QosEvent;
}();
export default QosEvent;